export default "/images/b03c53ed94e009e937b84cf81c75295b.avif";